import React, { PureComponent } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";
import "scss/components/charts/lineCharts.scss";

export default class LineCharts extends PureComponent {
  render() {
    const data = [
      {
        // name: "Page A",
        // pv: 2400,
        amt: 2400,
      },
      {
        // name: "Page B",
        // pv: 1398,
        amt: 2210,
      },
      {
        // name: "Page C",
        // pv: 9800,
        amt: 2290,
      },
      {
        // name: "Page D",
        // pv: 3908,
        amt: 2000,
      },
      {
        // name: "Page E",
        // pv: 4800,
        amt: 2181,
      },
    ];

    return (
      <div
        style={{
          width: "100%",
          height: 450,
          backgroundColor: "white",
          marginTop: "0.5%",
        }}
      >
        <ResponsiveContainer>
          <LineChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" label="ระยะเวลาเฉลี่ยในการปิด Job" />
            <YAxis>
              <Label
                angle={-90}
                value="% การปิด Job"
                position="insideLeft"
                style={{ textAnchor: "middle" }}
              />
            </YAxis>
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              // dataKey="ระยะเวลาเฉลี่ยในการปิด Job"
              // dataKey="ระยะเวลาเฉลี่ยในการปิด Job"
              stroke="#4267b2"
              activeDot={{ r: 8 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
